import React, { useState, useEffect } from 'react';
import { getSystemConfig } from '../../services/adminApi';
import { notify } from '../../utils/notify';
import './Settings.css';

function SystemSettings() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      setLoading(true);
      const response = await getSystemConfig();
      setConfig(response.data);
    } catch (err) {
      console.error('Failed to load system config:', err);
      notify.error('Failed to load system configuration');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="settings-loading">Loading system configuration...</div>;
  }

  if (!config) {
    return <div className="settings-error">Failed to load configuration</div>;
  }

  return (
    <div className="settings-page">
      <h2>System Configuration</h2>
      <p className="settings-note">
        Note: Configuration is read-only. To modify settings, update environment variables and restart the application.
      </p>

      <div className="settings-section">
        <h3>Application</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>App Name</label>
            <div className="config-value">{config.app.name}</div>
          </div>
          <div className="config-item">
            <label>Environment</label>
            <div className="config-value">{config.app.environment}</div>
          </div>
          <div className="config-item">
            <label>Debug Mode</label>
            <div className="config-value">{config.app.debug ? 'Enabled' : 'Disabled'}</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Database</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Host</label>
            <div className="config-value">{config.database.host}</div>
          </div>
          <div className="config-item">
            <label>Port</label>
            <div className="config-value">{config.database.port}</div>
          </div>
          <div className="config-item">
            <label>Database</label>
            <div className="config-value">{config.database.database}</div>
          </div>
          <div className="config-item">
            <label>User</label>
            <div className="config-value">{config.database.user}</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Qdrant Vector Databases</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Customer Care URL</label>
            <div className="config-value">{config.qdrant.customer_care_url}</div>
          </div>
          <div className="config-item">
            <label>Tutor URL</label>
            <div className="config-value">{config.qdrant.tutor_url}</div>
          </div>
          <div className="config-item">
            <label>Social URL</label>
            <div className="config-value">{config.qdrant.social_url}</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Security</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Algorithm</label>
            <div className="config-value">{config.security.algorithm}</div>
          </div>
          <div className="config-item">
            <label>Access Token Expiry</label>
            <div className="config-value">{config.security.access_token_expire_minutes} minutes</div>
          </div>
          <div className="config-item">
            <label>Refresh Token Expiry</label>
            <div className="config-value">{config.security.refresh_token_expire_days} days</div>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>Rate Limiting</h3>
        <div className="config-grid">
          <div className="config-item">
            <label>Requests per Minute</label>
            <div className="config-value">{config.rate_limiting.per_minute}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemSettings;

